import apiClient from './api.client'

export type BattleStatus = 'PENDING' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED'

export interface BattleStats {
  turns: number
  cardsPlayed: number
  damageDealt: number
  cardsBurned: number
}

export interface Battle {
  id: string
  status: BattleStatus
  winnerId?: string
  deck1Id: string
  deck2Id?: string
  spaceId?: string
  battleLog?: BattleLogEntry[]
  stats?: BattleStats
  turns: number
  createdAt: string
  completedAt?: string
}

export interface BattleLogEntry {
  turn: number
  player: number
  phase: string
  action: string
  details?: Record<string, unknown>
}

export interface CreateBattleRequest {
  deck1Id: string
  deck2Id: string
  spaceId?: string
}

export const battlesService = {
  async getBattles(): Promise<Battle[]> {
    const response = await apiClient.instance.get<{ success: boolean; data: Battle[] }>('/api/battles')
    return response.data.data
  },

  async getBattle(id: string): Promise<Battle | null> {
    const response = await apiClient.instance.get<{ success: boolean; data: Battle }>(`/api/battles/${id}`)
    return response.data.success ? response.data.data : null
  },

  async createBattle(battle: CreateBattleRequest): Promise<Battle> {
    const response = await apiClient.instance.post<{ success: boolean; data: Battle }>('/api/battles', battle)
    return response.data.data
  },

  async cancelBattle(id: string): Promise<void> {
    await apiClient.instance.post(`/api/battles/${id}/cancel`)
  },

  async getBattleLog(id: string): Promise<BattleLogEntry[]> {
    const response = await apiClient.instance.get<{ success: boolean; data: BattleLogEntry[] }>(`/api/battles/${id}/log`)
    return response.data.data
  },

  async simulate(deck1Id: string, deck2Id: string, iterations = 100): Promise<{ deck1Wins: number; deck2Wins: number }> {
    const response = await apiClient.instance.post<{ success: boolean; data: { deck1Wins: number; deck2Wins: number } }>('/api/battles/simulate', {
      deck1Id,
      deck2Id,
      iterations,
    })
    return response.data.data
  },
}
